import React from "react";
//import features from Material UI libraries
import { Box, Grid, Typography } from "@mui/material";
//import components
import ProjectCard from "../components/projectCard.jsx";
import SocialMedia from "../components/socialMedia.jsx";
//main funtion for export
export default function Projects() {
  //style={{ minHeight: '100vh' }}
  return (
    <Grid
      container
      spacing={6}
      display="flex"
      direction="row"
      align="center"
      justify="center"
      justifyContent="center"
      alignItems="flex-start"
    >
      <Grid item xs={12} md="auto">
        <SocialMedia />
      </Grid>
      <Grid item xs={12} md={3} lg={3}>
        <ProjectCard
          title="Node.js & Microsoft SQL Backend Server"
          asset="/thumbnails/mssql.png"
          alt="developer's app"
          text="Server created to accomodate the Stock Tracker App and other apps. It features Sequelize for easy data migration and querying. The server and database are each located in Azure"
          href="https://lb-be-server-core-1759871718.azurewebsites.net/"
          target="_blank"
        />
      </Grid>
      <Grid item xs={12} md={3} lg={4}>
        <ProjectCard
          title="Stock Tracker - Nuxt"
          asset="/thumbnails/stocks.png"
          alt="web application"
          text="A web application for tracking personal stock choices using Nuxt, Node.js, Express and Azure SQL Server.
          Users can sign up, log in with the use of tokens, to update their stocks and slect their currency. The app retrieves stock information using my dedicated Azure backend server. Additional pages bring market news and global market status information"
          href="https://stock-tracker-web-app-frontend.vercel.app/"
          target="_blank"
        />
      </Grid>
      <Grid item xs={12} md={3} lg={4}>
        <ProjectCard
          title="Full Stack Web App"
          asset="/thumbnails/medical.png"
          alt="web application"
          text="A web application for medical staff using React, Express, SQLite3
              and Node js. Admin staff can search, create and update client records, whilst managers can use it to review client and treatment data. The app allows practitioners to enter clinical information and procress, as well as monitor costs."
          href="https://medical-treatments.vercel.app/"
          target="_blank"
        />
      </Grid>
      <Grid item xs={12} md={3} lg={4}>
        <ProjectCard
          title="Clock App"
          asset="/thumbnails/clock.png"
          alt="clock application"
          text="Clock-Watcher, ideal for working from home. This is a React App with useState, useEffect and useRef hooks to implement a Material UI portal feature and make axios calls to keep time with world clocks."
          href="https://clock-watcher.vercel.app/"
          target="_blank"
        />
      </Grid>
      <Grid item xs={12}  md={3} lg={4}>
        <ProjectCard
          title="React Developer API"
          asset="https://cdn.glitch.global/02995824-9536-4918-8e4f-00dcb083b1bd/thumbnails%2Fclients.PNG?1647101600081"
          alt="records API"
          text="An API for collecting sample client records. Axios get requests are used to fetch data from an Express server using Node js. The app is available for developers seeking summary information to use for their own applications."
          href="https://client-records.vercel.app/"
          target="_blank"
        />
      </Grid>
      <Grid item xs={12} md={3} lg={4}>
        <ProjectCard
          title="React Developer App"
          asset="/thumbnails/special.png"
          alt="developer's app"
          text="Tool for getting React codes for special character symbols. This tool saves developers the time taken to research the correct format for implementing special characters whilst coding"
          href="https://special-characters-fawn.vercel.app"
          target="_blank"
        />
      </Grid>
      <Grid item xs={12} md={3} lg={4}>
        <ProjectCard
          title="Text-based game written in JAVA"
          asset="/thumbnails/gandor.png"
          alt="java game"
          text="Play Glandor online now. Click 'RUN' to start the game, which is powered by a 'while' loop and 'switch' statement. A number of hints and tools are provided for progressing through the game."
          href="https://replit.com/@ReetzOnline/gandor#replit.md"
          target="_blank"
        />
      </Grid>
      <Grid item xs={12}  md={3} lg={4}>
        <ProjectCard
          title="React Website and Contact form"
          asset="/thumbnails/contact.png"
          alt="react website"
          text="Full feature website using React Routing, Material UI library and EmailJS service. Styling for the site is primaryly completed using MUI's powerful tools. Visitors recieve an auto reply to their contact email address after submitting the contact form."
          href="/contact"
        />
      </Grid>
      <Grid item xs={12} md={3} lg={4}>
        <ProjectCard
          title="Entity Relationship Diagram for SQL"
          asset="/thumbnails/erd.png"
          alt="ERD design"
          text="Tables are designed for seamless retrieval of resident information. The design is based on a my years working in social care and could be used to implement a residential care application. "
          href="/documents/erd.png"
          target="_blank"
        />
      </Grid>
    </Grid>
  );
}
